export default __webpack_public_path__ + "8776d0637594f70380c7b15ac1d320dd.png";